import React from 'react';
import { motion } from 'framer-motion';
import { LucideSettings, LucideCpu, LucideNetwork } from 'lucide-react';

const IndustrialAutomation = () => {
  return (
    <div className="relative h-screen bg-obsidian text-white overflow-hidden">
      <div className="absolute inset-0 w-full h-full flex items-center justify-center overflow-hidden">
        
        {/* ── LAYER 1: FAR BACKGROUND ── */}
        <div className="absolute inset-0 z-0 overflow-hidden opacity-10 pointer-events-none">
          <motion.div 
            animate={{ rotate: 360, y: [0, 20, 0] }}
            transition={{ rotate: { duration: 100, repeat: Infinity, ease: "linear" }, y: { duration: 10, repeat: Infinity, ease: "easeInOut" } }}
            className="absolute -top-1/2 -left-1/4 will-change-transform"
          >
            <LucideSettings size={800} className="text-white/10" />
          </motion.div>
          <motion.div 
            animate={{ rotate: -360, y: [0, -20, 0] }}
            transition={{ rotate: { duration: 120, repeat: Infinity, ease: "linear" }, y: { duration: 12, repeat: Infinity, ease: "easeInOut" } }}
            className="absolute -bottom-1/4 -right-1/4 will-change-transform"
          >
            <LucideSettings size={600} className="text-white/10" />
          </motion.div>
        </div>

        {/* ── LAYER 4: UI CONTENT ── */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, ease: "easeOut" }}
          className="layer-ui relative z-10 text-center max-w-2xl px-8 will-change-transform"
        >
          <div className="flex justify-center gap-6 mb-12">
            {[LucideCpu, LucideNetwork, LucideSettings].map((Icon, i) => (
              <motion.div
                key={i}
                animate={{ 
                  opacity: [0.4, 1, 0.4], 
                  scale: [0.95, 1.05, 0.95],
                  boxShadow: ["0px 0px 0px rgba(212,175,55,0)", "0px 0px 20px rgba(212,175,55,0.3)", "0px 0px 0px rgba(212,175,55,0)"]
                }}
                transition={{ 
                  duration: 1.5, 
                  repeat: Infinity, 
                  delay: i * 0.2, 
                  ease: "easeInOut" 
                }}
                className="relative w-16 h-16 rounded-2xl glass-surface-v3 flex items-center justify-center text-gold/80 border border-white/10"
              >
                <Icon size={24} />
              </motion.div>
            ))}
          </div>
          
          <span className="text-[10px] font-mono uppercase tracking-[0.6em] text-gold/60 mb-6 block">Future of Industry</span>
          <h1 className="text-6xl md:text-8xl font-serif font-light mb-8 tracking-tight">
            Industrial <br />
            <span className="italic text-gold">Automation.</span>
          </h1>
          <div className="w-24 h-px bg-gold/30 mx-auto mb-12" />
          <h2 className="text-xl md:text-2xl font-light text-white/40 tracking-widest uppercase">Coming Soon</h2>
          
          <div className="mt-20">
            <button className="px-10 py-4 border border-white/10 rounded-full text-[10px] uppercase tracking-ultra font-bold hover:bg-white hover:text-obsidian transition-all duration-500">
              Notify Me
            </button>
          </div>
        </motion.div>

        {/* ── Progress Indicator ── */}
        <div className="absolute bottom-12 left-12 right-12 flex justify-between items-end">
          <div className="flex flex-col gap-2">
            <span className="text-[8px] font-mono text-white/20 uppercase tracking-widest">Development Phase</span>
            <div className="flex gap-1">
              {[1, 2, 3, 4].map(i => (
                <div key={i} className={`h-1 w-8 rounded-full ${i <= 3 ? 'bg-gold/40' : 'bg-white/5'}`} />
              ))}
            </div>
          </div>
          <div className="text-[10px] font-mono text-white/20">
            IOTIQ INDUSTRIAL · VER 2.0
          </div>
        </div>
      </div>
    </div>
  );
};

export default IndustrialAutomation;